// extracted by mini-css-extract-plugin
export default {"root":"zbuXU","noAction":"A6zuO","desktop":"j84IP"};